import React from "react";
import { Info } from "lucide-react";

/** Grey information box: an info icon, a title and an explanation under it. */
const InfoBox = ({ title, children, className = "" }) => (
    <div className={`flex items-start gap-3 rounded-lg bg-gray-50 p-4 ${className}`} role="status">
        <Info size={18} className="mt-0.5 shrink-0 text-gray-500" aria-hidden="true" />
        <div className="flex min-w-0 flex-col gap-1">
            {title ? <p className="ft-sm font-medium text-gray-900">{title}</p> : null}
            {children ? <div className="ft-sm text-gray-500">{children}</div> : null}
        </div>
    </div>
);

export default InfoBox;
